// types
import { PRODUCT_DETAILS, PRODUCT_LIST, PRODUCT_REVIEW_LIST } from 'common/apiExampleData';
import { Products, ProductsFilter } from 'types/e-commerce';

import { fetcher } from 'utils/fetch';

// ==============================|| API - PRODUCTS ||============================== //

// ⬇️ this is the loader for the detail route
export async function loader() {
  return PRODUCT_LIST as Products[];
  // NOT YET IMPLEMENTED
  /*
  try {
    const response = await axios.get('/api/products/list');
    return response.data.products as Products[];
  } catch (error) {
    return error;
  }
    */
}

export async function filterProducts(filter: ProductsFilter) {
  return {}
  // NOT YET IMPLEMENTED
  // return await axios.post('/api/products/filter', { filter });
}

export async function productLoader({ params }: any) {
  return PRODUCT_DETAILS[params.id] as Products;
  // NOT YET IMPLEMENTED
  /*
  try {
    const response = await axios.post('/api/product/details', { id: params.id });
    return response.data as Products;
  } catch (error) {
    return error;
  }
    */
}

export async function getRelatedProducts(id: string | undefined) {
  return {}
  // NOT YET IMPLEMENTED  
  // return await axios.post('/api/product/related', { id });
}

export async function getProductReviews() {
  return PRODUCT_REVIEW_LIST;
  // NOT YET IMPLEMENTED  
  // return await axios.get('/api/review/list');
}
